import { cn } from "@/lib/tailwind";
import React from "react";

type tooltipPosition = "topLeft" | "bottomLeft" | "topRight" | "bottomRight";
interface TooltipProps {
  className?: string;
  display: boolean;
  title?: string;
  description: string;
  position?: tooltipPosition;
}

const Tooltip = ({
  display,
  description,
  title,
  className,
  position = "topRight",
}: TooltipProps) => {
  var positionStyling = "";
  switch (position) {
    case "topRight":
      positionStyling = "ltr:right-6 rtl:left-6 top-6";
      break;
    case "bottomRight":
      positionStyling = "ltr:right-6 rtl:left-6 bottom-6";
      break;
    case "topLeft":
      positionStyling = "ltr:left-6 rtl:right-6 top-6";
      break;
    case "bottomLeft":
      positionStyling = "ltr:left-6 rtl:right-6 bottom-6";
  }
  return (
    <span
      className={cn(
        "absolute -top-8 z-[10] w-[25rem] bg-white p-4 text-[0.8em] shadow-md transition-all ease-in",
        display ? "block" : "hidden",
        positionStyling,
        className,
      )}
    >
      {title && <h3 className="py-1 font-semibold">{title}</h3>}
      <div className="text-tertiary-6">{description}</div>
    </span>
  );
};

export default Tooltip;
